import { t } from "i18next";
import React from "react";
import { toCamelCase } from "../../utils/Helpers";

const PriceOptionsCard = ({
    pricePlans,
    selectedPlan,
    setSelectedPlan,
    isPreview,
    percentageDiscount,
    buttonClassname = "",
    isBorderLess = false,
    isVertical = false,
}) => {
    const handleSelect = (index) => {
        setSelectedPlan(index);
    };

    const getPriceAfterDiscount = (price, discount) => {
        return +price * (1 - discount / 100);
    };

    const getPriceNumber = (
        price,
        currencyName,
        isSelected,
        isLineThrough = false
    ) => {
        return isLineThrough ? (
            <div className="text-gray-400 line-through">
                <i className={`fas fa-${currencyName}-sign`} />
                <span>{(+price).toFixed(2) || 0}</span>
            </div>
        ) : (
            <>
                <i
                    className={`fa-lg fas fa-${currencyName}-sign ${
                        !isPreview && isSelected
                            ? "text-primary-color-orange"
                            : "text-primary-blue"
                    }`}
                ></i>
                <h3>{(+price)?.toFixed(2) || 0}</h3>
            </>
        );
    };

    const getPrice = (plan, index) => {
        if (plan?.price == 0) {
            return <h3 className="uppercase">{t("free")}</h3>;
        } else if (percentageDiscount) {
            return (
                <div className="flex items-center">
                    {getPriceNumber(
                        plan?.price,
                        plan?.currencyName,
                        selectedPlan === index,
                        true
                    )}
                    <div className="ml-1 flex items-center">
                        {getPriceNumber(
                            getPriceAfterDiscount(
                                plan?.price,
                                percentageDiscount
                            ),
                            plan?.currencyName,
                            selectedPlan === index
                        )}
                    </div>
                </div>
            );
        }

        return getPriceNumber(
            plan?.price,
            plan?.currencyName,
            selectedPlan === index
        );
    };
    const renderPricePlans = () => {
        return (
            <div
                className={`grid grid-${isVertical ? "rows" : "cols"}-${
                    isPreview ? "2" : pricePlans.length || "2"
                } gap-4 w-full`}
            >
                {pricePlans &&
                    pricePlans.map((plan, index) => {
                        return (
                            <button
                                key={index}
                                className={`w-full h-16 mr-2 border-solid rounded-md ${
                                    isBorderLess ? "" : "border"
                                } ${buttonClassname} ${
                                    isPreview
                                        ? "cursor-default"
                                        : "cursor-pointer"
                                } ${
                                    !isPreview && selectedPlan === index
                                        ? "border-primary-color-orange"
                                        : "border-secondary-color-lighter-blue"
                                }`}
                                disabled={isPreview}
                                onClick={() =>
                                    !isPreview && handleSelect(index)
                                }
                            >
                                <div className="price-items text-center justify-center m-auto">
                                    <h4 className="uppercase">
                                        {t(toCamelCase(plan?.name))}
                                    </h4>
                                </div>
                                <div
                                    className={`flex justify-center items-center m-auto price-items text-center mt-1 ${
                                        !isPreview &&
                                        selectedPlan === index &&
                                        "selected"
                                    }`}
                                >
                                    {getPrice(plan, index)}
                                </div>
                            </button>
                        );
                    })}
            </div>
        );
    };

    return renderPricePlans();
};

export default PriceOptionsCard;
